import React from 'react';
import { useWalkie } from '../contexts/WalkieContext';

export default function TransmissionHistory() {
  const { transmissions, channels, activeChannelId } = useWalkie();

  // Filter by active channel or show all
  const filtered = activeChannelId
    ? transmissions.filter(t => t.channelId === activeChannelId)
    : transmissions;

  const formatDuration = (sec: number): string => {
    if (sec < 60) return `${sec}s`;
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}m ${s}s`;
  };

  const formatTime = (iso: string): string => {
    return new Date(iso).toLocaleTimeString('ar-SA', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-700">
        <h3 className="text-sm font-semibold text-gray-400">سجل الإرسالات</h3>
        <span className="text-xs text-gray-600">{filtered.length} إرسال</span>
      </div>

      {/* Table */}
      <div className="flex-1 overflow-y-auto">
        {filtered.length === 0 ? (
          <div className="flex items-center justify-center h-full text-gray-600 text-sm">
            لا توجد إرسالات بعد
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-gray-800 text-gray-400">
              <tr>
                <th className="px-4 py-2 text-right font-normal">الحارس</th>
                <th className="px-4 py-2 text-right font-normal">القناة</th>
                <th className="px-4 py-2 text-right font-normal">المدة</th>
                <th className="px-4 py-2 text-right font-normal">الوقت</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((t, idx) => (
                <tr
                  key={t.id}
                  className={`
                    border-b border-gray-800 hover:bg-gray-800/50 transition-colors
                    ${idx === 0 ? 'bg-emerald-900/10' : ''}
                  `}
                >
                  <td className="px-4 py-2 text-gray-200 font-medium">
                    {idx === 0 && <span className="text-emerald-500 ml-1">●</span>}
                    {t.userName}
                  </td>
                  <td className="px-4 py-2 text-gray-400">{t.channelName}</td>
                  <td className="px-4 py-2 text-gray-400 font-mono">
                    {formatDuration(t.duration)}
                  </td>
                  <td className="px-4 py-2 text-gray-500 font-mono">
                    {formatTime(t.timestamp)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
